function MobileMenuItem({
  textLabel = "Menu Item",
  iconUrl = "/icon/without_w_b_icon.png",
  isSpecial = false,
}) {
  const icon = iconUrl ? (
    <div className='mobile-menu-icon-wrapper'>
      <img src={iconUrl} alt={`${textLabel} icon`} className='mobilemenu-item-icon' />
    </div>
  ) : null;
  const label = <div className='mobilemenu-item-label'>{textLabel}</div>;
  const iconArrow = <img src="/icon/icon-arrow-right.png" alt="Arrow icon" className='mobilemenu-item-arrow' />

  return (
    <div className={`mobilemenu-item ${isSpecial ? "menu-special" : ""}`}>
      {icon}
      {label}
      {iconArrow}
    </div>
  );
}

export default MobileMenuItem;
